export const EnrollmentOptions = {
  optIn: {
    optIn: true,
    optOut: false,
    isDefaultEnrollment: false
  },
  optOut: {
    optIn: false,
    optOut: true,
    isDefaultEnrollment: false
  },
  optInNow: {
    optIn: false,
    optOut: false,
    isDefaultEnrollment: false
  },
  isDefaultEnrollment: {
    optIn: false,
    optOut: false,
    isDefaultEnrollment: true
  }
};
